/* eslint-disable prettier/prettier */
/* prettier-ignore-file */
/* eslint-disable */

import { useCallback, useState } from 'react';
import {
	invitationService,
	SendInviteRequest,
	InviteSummary,
	CreateInviteResponse,
	CreateInviteRequest,
	AcceptInvitationRequest,
	VerifyInvitationResponse,
} from '../services/invitationService';

export function useInvitation() {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);
	const [success, setSuccess] = useState(false);

	const [invite, setInvite] = useState<InviteSummary | null>(null);
	const [createdInvite, setCreatedInvite] =
		useState<CreateInviteResponse | null>(null);
	const [cancelSuccess, setCancelSuccess] = useState(false);

	// ===============================
	// 🔹 Send Invite
	// ===============================
	const sendInvite = async (payload: SendInviteRequest) => {
		setLoading(true);
		setError(null);
		setSuccess(false);

		try {
			const res = await invitationService.sendInvite(payload);

			if (res.success) {
				setInvite(res.data);
				setSuccess(true);
				return res.data;
			} else {
				setError(res.message || 'Failed to send invite');
				return null;
			}
		} catch (err: any) {
			console.error('Hook sendInvite error:', err);
			setError(err.message || 'Something went wrong');
			return null;
		} finally {
			setLoading(false);
		}
	};

	// ===============================
	// 🔹 Create Invitation (NEW)
	// ===============================
	const createInvite = async (payload: CreateInviteRequest) => {
	setLoading(true);
	setError(null);
	setSuccess(false);

	try {
		const res = await invitationService.createInvite(payload);

		if (res.success) {
    setCreatedInvite(res.data);
    setSuccess(true);
}

return res;
	} catch (err: any) {
    return {
        success: false,
        message:
            err?.response?.data?.message ||
            err.message ||
            'Something went wrong',
    };
} finally {
		setLoading(false);
	}
};
	// ===============================
	// 🔹 Cancel Invite
	// ===============================
	const cancelInvite = async (inviteId: string) => {
		setLoading(true);
		setError(null);
		setCancelSuccess(false);

		try {
			const res = await invitationService.cancelInvite(inviteId);

			if (res.success) {
				setCancelSuccess(true);
				return true;
			} else {
				setError(res.message || 'Failed to cancel invite');
				return false;
			}
		} catch (err: any) {
			console.error('Hook cancelInvite error:', err);
			setError(err.message || 'Something went wrong');
			return false;
		} finally {
			setLoading(false);
		}
	};
const [verifiedInvitation, setVerifiedInvitation] =
    useState<VerifyInvitationResponse | null>(null);
// const verifyInvitation = async (token: string) => {
//     setLoading(true);
//     setError(null);

//     try {
//         const res = await invitationService.verifyInvitation(token);

//         if (res.success) {
//             setVerifiedInvitation(res.data);
//             return res;
//         }

//         setError(res.message || 'Invalid invitation');
//         return res;
//     } catch (err: any) {
//         const message =
//             err?.message || 'Unable to verify invitation';

//         setError(message);

//         return {
//             success: false,
//             message,
//             data: {} as VerifyInvitationResponse,
//         };
//     } finally {
//         setLoading(false);
//     }
// };
const verifyInvitation = useCallback(
    // async (token: string): Promise<ApiResponse<VerifyInvitationResponse>> => {
	 async (token: string) => {
        setLoading(true);
        setError(null);

        try {
            const res = await invitationService.verifyInvitation(token);

            if (res.success) {
                setVerifiedInvitation(res.data);
                return res;
            }

            setError(res.message || 'Invalid invitation');
            return res;
        } catch (err: any) {
            const message =
                err?.message || 'Unable to verify invitation';

            setError(message);

            return {
                success: false,
                message,
                data: {} as VerifyInvitationResponse,
            };
        } finally {
            setLoading(false);
        }
    },
    []
);
const acceptInvitation = async (
    token: string,
    payload: AcceptInvitationRequest
) => {
    setLoading(true);
    setError(null);

    try {
        const res =
            await invitationService.acceptInvitation(
                token,
                payload
            );

        if (res.success) {
            setSuccess(true);
        } else {
            setError(
                res.message ||
                'Failed to accept invitation'
            );
        }

        return res;
    } catch (err: any) {
        const message =
            err?.message ||
            'Something went wrong';

        setError(message);

        return {
            success: false,
            message,
        };
    } finally {
        setLoading(false);
    }
};

	// ===============================
	// Return
	// ===============================
	return {
		sendInvite,
		createInvite, // ✅ ADD THIS
		verifyInvitation,
    acceptInvitation,
		cancelInvite,

		invite,
		createdInvite,

		loading,
		error,
		success,
		cancelSuccess, // optional

		setInvite,
		setCreatedInvite, // optional but useful
	};
}
